/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Kpi_Eu_ShareInputs */



/**
* | output |
* | --- |
* | "Hosted in Europe" |
*
* @param {Dashboard_Kpi_Eu_ShareInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const dashboard_kpi_eu_share = /** @type {((inputs?: Dashboard_Kpi_Eu_ShareInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Kpi_Eu_ShareInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("In Europa gehostet")
	return /** @type {LocalizedString} */ ("Hosted in Europe")
});